import { Injectable } from '@angular/core';
import { Http, Headers, URLSearchParams, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import { User } from '../models/User';
import { environment } from '../../../environments/environment';
import { tokenStorage } from '../core/tokenStorage';

@Injectable()
export class AuthService {
  public token: string;

  public static currentUser() {
    const userJSON = JSON.parse(tokenStorage.getItem('currentUser'));
    if (!userJSON) {
      return null;
    }
    const user = new User(userJSON);
    user.token = userJSON.token;
    return user;
  }

  constructor(private http: Http) {
    const currentUser = JSON.parse(tokenStorage.getItem('currentUser'));
    this.token = currentUser && currentUser.token;
  }

  private urlEncode(obj: Object): string {
    const urlSearchParams = new URLSearchParams();
    for (const key in obj) {
      if (key) {
        urlSearchParams.append(key, obj[key]);
      }
    }
    return urlSearchParams.toString();
  }

  login(loginID: number, password: string) {
    const headers = new Headers({
      'Content-Type': 'application/x-www-form-urlencoded'
    });
    const options = new RequestOptions({ headers: headers });

    return this.http
      .post(
        environment.api.baseUrl + environment.api.singIn,
        this.urlEncode({
          loginID: loginID,
          password: btoa(password)
        }),
        options
      )
      .toPromise()
      .then(response => {
        const json = response.json();
        const token = json && json.token;
        if (token) {
          const jsonUser = JSON.parse(
            json.arguments.filter(item => item.key === 'user')[0].value
          );

          if (jsonUser) {
            this.token = token;
            const user = new User(jsonUser);
            user.token = token;
            tokenStorage.setItem('currentUser', JSON.stringify(user));
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      })
      .then(data => {
        return data;
      });
  }

  logout(): void {
    this.token = null;
    tokenStorage.removeItem('currentUser');
  }
}



// WEBPACK FOOTER //
// E:/proj/news12/zb-n12/scadmin/client/src/app/shared/services/auth.service.ts